import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-cy"]
const _hoisted_2 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2707_71239)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.83343 8.85038L11.1954 3.48779L12.0208 4.31263L5.83343 10.5L2.12109 6.78771L2.94593 5.96288L5.83343 8.85038Z",
    fill: "#3C92FE"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2707_71239" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "acCheckbox_label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "acCheckbox",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCheckbox && _ctx.toggleCheckbox(...args))),
    "data-cy": `checkbox-${_ctx.name}`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["acCheckbox_checkbox", {
        '-checked': _ctx.modelValue
      }])
    }, [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
        : _createCommentVNode("", true)
    ], 2),
    _renderSlot(_ctx.$slots, "label", {}, () => [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_6, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}